import React from 'react';
import ReactDOM from 'react-dom/client';

import { App } from './App';
import './css/global.css';

const el = document.getElementById('maxx-roleta-theme');

if (el) {
	ReactDOM.createRoot(el).render(
		<React.StrictMode>
			<App />
		</React.StrictMode>,
	);
}
